<template>
  <div class="itin-flight" v-if="payments.length">
    <div class="itin-subheader">
      <h4>
        <font-awesome-icon icon="credit-card"/>
        {{ $t('Pagos') }}
      </h4>
    </div>
    <div class="payment-list">
      <div class="payment-card" v-for="(payment, index) in payments" :key="index">
        <div class="payment-card-icon">
          <font-awesome-icon icon="credit-card"/>
        </div>
        <div class="payment-card-body">
          <div class="payment-card-name">{{ $t(payment.name) }}</div>
          <div class="payment-card-meta">
            <span v-if="payment.date">{{payment.date}}</span>
            <span v-if="payment.cardNumber"> · {{payment.cardNumber}}</span>
          </div>
          <p class="btn-link mb-0 mt-1 payment-card-action" @click="sendEmail(payment.MPPaymentID)" v-if="payment.url">
            {{ $t('Reenviar cupón de pago') }}
          </p>
        </div>
          <div class="payment-card-amount" :class="{ 'is-refund': payment.isRefund }">
            {{ payment.amount }}
          </div>
        <div class="payment-card-status" :class="payment.statusClass">{{payment.status}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import moment from 'moment';
  import {formatMoney} from "../../utils/utils";
  import {resendEmailPayment} from "../../api/api";
  export default {
    name: 'payment-summary',
    computed: {
      ...mapState(['booking']),
      payments: function() {
        if (!this.booking || !this.booking.Payments) return [];
        var result = [];
        var that = this;
        this.booking.Payments.forEach(function(element) {
          var statusInfo = that.getStatus(element);
          var amount = parseFloat(element.CollectedPaymentAmount);
          result.push({
            "name": element.PaymentMethod && element.PaymentMethod.Name ? element.PaymentMethod.Name : that.$t('Pago'),
            "amount": formatMoney(amount) + " " + (element.CurrencyCode || 'ARS'),
            "isRefund": amount < 0,
            "cardNumber": that.cardNumber(element),
            "date": element.ApprovalUTC ? moment(element.ApprovalUTC).locale(that.$locale()).format('DD MMM YYYY') : '',
            "status": statusInfo.label,
            "statusClass": statusInfo.css,
            "url": that.getMPUrl(element),
            "MPPaymentID": element.MPPaymentID
          })
        });
        return result;
      }
    },
    methods:  {
      getStatus: function(payment) {
        if (payment.AuthorizationStatus == 4) {
          return {label: this.$t('Aprobado'), css: 'is-approved'};
        }

        if (!payment.MercadoPagoPayment || payment.MercadoPagoPayment.Status == 'FAILED') {
          return {label: this.$t('Erróneo — no procesado'), css: 'is-error'};
        }

        if (payment.MercadoPagoPayment.Status == 'approved') {
          return {label: this.$t('Pendiente — llamar al call center'), css: 'is-warning'};
        }

        if (payment.MercadoPagoPayment.Status == 'pending' && payment.MercadoPagoPayment.type == 'ticket') {
          return {label: this.$t('Pendiente de pago'), css: 'is-pending'};
        }

        return {
          label: this.$t('Rechazado') + (payment.AuthorizationStatusDetailMessage ? ' (' + payment.AuthorizationStatusDetailMessage + ')' : ''),
          css: 'is-error'
        };
      },
      cardNumber: function(payment) {
        if (payment.MercadoPagoPayment && payment.MercadoPagoPayment.type == 'ticket') {
          return ""
        }
        return payment.AccountNumber;
      },
      getMPUrl: function(payment) {
        if (payment.MercadoPagoPayment && payment.MercadoPagoPayment.type == 'ticket' && payment.AuthorizationStatus == 2) {
          return payment.MercadoPagoPayment.external_resource_url;
        }
        return null;
      },
      sendEmail: function(MPPaymentID) {
        this.$store.commit('loading', true);
        resendEmailPayment(this.booking.BookingID, this.booking.RecordLocator, MPPaymentID, (result) => {
          this.$store.commit('loading', false);
        })
      }
    }
  }
</script>

<style scoped>
.payment-list {
  padding: 16px;
  background: #fafafa;
}
.payment-card {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: #fff;
  border: 2px solid #e5e5e5;
  border-radius: 10px;
  padding: 14px 16px;
  text-align: left;
  gap: 8px 12px;
}
.payment-card + .payment-card {
  margin-top: 12px;
}
.payment-card-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f3e8e8;
  color: #AA1E1E;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}
.payment-card-body {
  flex: 1;
  min-width: 160px;
}
.payment-card-name {
  font-weight: 700;
  color: #333;
}
.payment-card-meta {
  font-size: 13px;
  color: #666;
}
.payment-card-action {
  font-size: 13px;
  cursor: pointer;
  color: #AA1E1E;
}
.payment-card-amount {
  font-weight: 700;
  font-size: 18px;
  color: #333;
  margin-left: auto;
}
.payment-card-amount.is-refund {
  color: #1a73e8;
}
.payment-card-status {
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  padding: 4px 12px;
  white-space: nowrap;
}
.payment-card-status.is-approved {
  background: #e6f6e8;
  color: #1b7a2b;
}
.payment-card-status.is-pending,
.payment-card-status.is-warning {
  background: #fff4d6;
  color: #8a6d00;
}
.payment-card-status.is-error {
  background: #fde8e8;
  color: #AA1E1E;
}
</style>
